// Shared helpers for parsing Digital Core smartthermostat offer products, used by flows that sell
// a primary device bundled with optional add-ons (e.g. bundleFlow's thermostat, dongleFlow's dongle).
export type OfferApiProduct = {
  id?: string;
  productType?: string;
  unitPrice?: number;
  discount?: { amount?: number; description?: string; discountDurationDetails?: { duration?: number } };
};

export const isSubscriptionProduct = (product?: OfferApiProduct): boolean =>
  !!product?.productType?.includes('Subscription');

export const findSubscriptionProduct = (products?: OfferApiProduct[]): OfferApiProduct | undefined =>
  products?.find(isSubscriptionProduct);

export const getDeviceUnitPrice = (products?: OfferApiProduct[]): number | undefined => {
  if (!products?.length) return undefined;

  const deviceProduct = products.find(product => !isSubscriptionProduct(product));

  return deviceProduct?.unitPrice ?? products[0]?.unitPrice;
};

// Matches a product by productType keyword (e.g. 'SmartThermostat'/'RealtimeThuis'), scoped to
// device or subscription. Used instead of positional picking since an offer can bundle multiple
// products and their order in the API response isn't guaranteed.
export const findProductByKeyword = (
  products: OfferApiProduct[] | undefined,
  keyword: string,
  isSubscription: boolean,
): OfferApiProduct | undefined =>
  products?.find(
    product =>
      product.productType?.toLowerCase().includes(keyword.toLowerCase()) &&
      isSubscriptionProduct(product) === isSubscription,
  );

export type OfferCustomerProfile = Pick<
  ReturnType<(typeof import('@eneco/hooks/profile'))['useCustomerProfileAccount']>,
  'error' | 'isLoading'
>;
